import React, { useState } from "react";
import useWebsockets from "../../hooks/use-websockets";

export const NotificationContext = React.createContext();

const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const removeNotification = (item) => {
        setNotifications((previousNotifications) =>
            previousNotifications.filter((notification) => notification.id !== item.id)
        );
    };

    const onMessage = (data) => {
        if (data.type === "all-notifications") {
            setNotifications([...data.notifications]);
        } else if (data.type === "new-notifications") {
            setNotifications([...data.notifications, ...notifications]);
        } else {
            console.log(data);
        }
    };

    useWebsockets(onMessage);

    const providerValue = React.useMemo(
        () => ({
            notifications,
            setNotifications,
            removeNotification,
        }),
        [notifications]
    );

    return (
        <NotificationContext.Provider value={providerValue}>
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationProvider;
